import { css, SerializedStyles } from '@emotion/core'

import { Color } from '../../../enums/color'
import { InputWrapperProps } from '../types/inputWrapperProps'

interface AppearanceProps {
  backgroundColor: Color | undefined
  borderColor: Color | undefined
  hasInnerShadow: boolean
}

type GetAppearanceProps = Pick<InputWrapperProps, 'bordered' | 'autoCompleted'>

export const getAppearanceStyle = ({ bordered, autoCompleted }: GetAppearanceProps): SerializedStyles => {
  const appearance: AppearanceProps = {
    backgroundColor: Color.White,
    borderColor: Color.Grey200,
    hasInnerShadow: true,
  }

  if (autoCompleted) {
    appearance.backgroundColor = Color.Lavender50
    appearance.borderColor = Color.Lavender100
  }

  if (!bordered) {
    appearance.borderColor = undefined
    appearance.hasInnerShadow = false
  }

  return css`
    border: 1px solid ${appearance.borderColor || 'transparent'};
    background-color: ${appearance.backgroundColor};
  `
}
